import { React } from "react";
import { useNavigate } from "react-router-dom"
import { Grid } from 'antd-mobile';
import { page } from "utils/constant";
import { hotService1, hotService2, hotService3, hotService4 } from "utils/getImg";
import "static/css/hotServiceCard.css"

const HotServiceItems = [
  {
    id: 1,
    img: hotService1,
    backColor: 'hotService1',
    title: '就业创业',
    content: '人社大厅一站式就业'
  },
  {
    id: 2,
    img: hotService2,
    backColor: 'hotService2',
    title: '失业保险',
    content: '失业保险在线申领'
  },
  {
    id: 3,
    img: hotService3,
    backColor: 'hotService3',
    title: '培训创业',
    content: '了解最新培训创业'
  },
  {
    id: 4,
    img: hotService4,
    backColor: 'hotService4',
    title: '就业帮扶',
    content: '就业帮扶在线申领'
  },
]

/** 热门服务 */
export function HotServiceCard() {
  const navigate = useNavigate()
  const {SERVICE } = page


  /** 点击热门服务 */
  function handleHotServiceClick(props) {
    navigate(`/${SERVICE}`, { state: { defaultActiveKey: [`${props}`] } })
  }

  return (
    <Grid columns={2} gap={12}>
      {
        HotServiceItems.map(item =>
          <div
            key={item.id}
            className={`hotServiceCard ${item.backColor}`}
            onClick={() => handleHotServiceClick(item.id)}
          >
            <img src={item.img} alt={item.title}></img>
            <div className="hotServiceContent">
              <div className="hotServiceTitle">{item.title}</div>
              <div className="hotServiceDetail">{item.content}</div>
            </div>
          </div>
        )
      }
    </Grid >
  )
}